import React from "react";

const RequestMoneyBus = (props) => {
  const options = [
    {
      text: 'What is INTERAC e-Transfer Request Money?',
      handler: props.actionProvider.RequestMoneyBus1,
      id: 1
    },
    {
      text: 'I’m invoicing a client via Interac e-Transfer and want to add the invoice number, HST number and business address. Where do I add this information?',
      handler: props.actionProvider.RequestMoneyBus2,
      id: 2
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default RequestMoneyBus;